<template>
  <div>
    <transition name="custom-classes-transition" enter-active-class="animated fadeIn faster">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Songwriters'
}
</script>
